<button
  mat-icon-button
  class="eiq-icon-button"
  [attr.data-testid]="testId() ? testId() + '-icon-button' : null"
  [color]="color()"
  [matTooltip]="tooltip()"
  [ngClass]="[size(), style(), disabled() ? 'disabled' : '']"
  [disabled]="disabled() || loading()"
  (click)="!disabled() && clicked.emit()"
>
  @if (loading()) {
    <mat-spinner diameter="20" color="light"></mat-spinner>
  } @else {
    <fa-icon [icon]="icon()"></fa-icon>
  }
</button>
